import { useMutation, useQueryClient } from '@tanstack/react-query';
import OutreachService from '@/services/OutreachService';
import { DASHBOARD_KEYS } from '@/state/data/dashboard/keys';
import { scheduleInvalidate } from '@/state/data/_shared/wf-race';

// Bumps careteam_last_seen_at; reconciles the dashboard past the write SLA so
// the unread badge drops. Service swallows PATCH errors → onSettled re-reads either way.
export function useMarkChatViewed() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userid: string | number) => OutreachService.markChatViewedByCareteam(userid),
    onSettled: () => {
      scheduleInvalidate(qc, DASHBOARD_KEYS.all);
    },
  });
}

// Resets careteam_last_seen_at to the epoch so the conversation re-flags unread.
// Mirror of useMarkChatViewed. Service swallows PATCH errors → onSettled re-reads either way.
export function useMarkChatUnread() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userid: string | number) => OutreachService.markChatUnreadByCareteam(userid),
    onSettled: () => {
      scheduleInvalidate(qc, DASHBOARD_KEYS.all);
    },
  });
}
